var _path, _path2, _path3, _path4, _path5, _rect, _polygon, _path6, _path7, _polyline, _path8, _path9, _polygon2, _rect2, _polygon3, _ellipse, _ellipse2, _ellipse3, _path10, _polyline2, _path11, _path12, _polygon4, _path13, _path14, _ellipse4, _ellipse5, _ellipse6, _path15, _path16, _polygon5, _circle, _path17, _path18, _rect3, _polyline3, _path19, _path20, _path21, _path22, _path23, _path24, _polygon6, _polygon7, _polyline4, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _path25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawToTheStarsRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 809.16369,
    height: 657.27702,
    viewBox: "0 0 809.16369 657.27702",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M886.05077,723.25123v49.04a7.00763,7.00763,0,0,1-7,7h-556a7.01521,7.01521,0,0,1-7-7v-62.12c.66-.69995,1.32-1.38995,2-2.07995a384.97527,384.97527,0,0,1,566,12.88C884.73076,721.72126,885.3908,722.49122,886.05077,723.25123Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#c41437"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M702.55077,185.28126q-.84-.51-1.68-.99h-58.44c-.42.66-.82,1.33-1.21,2h63.01C703.67076,185.95124,703.11077,185.62122,702.55077,185.28126Zm-386.5,197.47v14.9c.25.02.51.02.76.03l-.5,28.64-.26-.14v2.82l.21.11-.21,12.01v41.4h2v-106.52Q317.21077,379.24128,316.05077,382.75123Zm386.5-197.47q-.84-.51-1.68-.99h-58.44c-.42.66-.82,1.33-1.21,2h63.01C703.67076,185.95124,703.11077,185.62122,702.55077,185.28126Zm176.5-.99h-556a7.0077,7.0077,0,0,0-7,7v581a7.01521,7.01521,0,0,0,7,7h556a7.00763,7.00763,0,0,0,7-7v-581A7.00766,7.00766,0,0,0,879.05077,184.29121Zm5,588a5.00181,5.00181,0,0,1-5,5h-556a5.00185,5.00185,0,0,1-5-5v-581a5.00828,5.00828,0,0,1,5-5h556a5.00824,5.00824,0,0,1,5,5Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M546.57954,700.70834l-19.83221.5476a13.81233,13.81233,0,0,1-8.48582-2.37891c-2.15367-1.602-3.14159-3.76763-2.70847-5.94251l3.90258-19.61285c.73546-3.7,5.26958-6.49709,10.77994-6.6493l10.95246-.30244c5.51034-.15215,10.19188,2.39045,11.1305,6.04428l4.979,19.36762c.55248,2.14764-.31449,4.36453-2.37642,6.08292A13.81231,13.81231,0,0,1,546.57954,700.70834Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M667.20992,700.14778l-19.83215.54763a13.81226,13.81226,0,0,1-8.48582-2.37891c-2.15362-1.602-3.14159-3.76763-2.70848-5.94251l3.90259-19.61285c.73546-3.7,5.2696-6.49714,10.77993-6.6493l10.95246-.30243c5.5104-.15214,10.19189,2.39044,11.1305,6.04427l4.979,19.36762c.55246,2.1477-.31448,4.36453-2.37641,6.08293A13.81223,13.81223,0,0,1,667.20992,700.14778Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M477.71428,533.6434a4.33143,4.33143,0,0,1,1.595-8.30761L704.777,519.11a4.33,4.33,0,0,1,4.4488,4.208l0,.00038a4.33573,4.33573,0,0,1-4.20924,4.44844l-.00045-.00019L479.54839,533.9923A4.30673,4.30673,0,0,1,477.71428,533.6434Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 499.4665,
    y: 459.85109,
    width: 64.47382,
    height: 217.68039,
    transform: "translate(-209.03562 -107.12078) rotate(-1.58175)",
    fill: "#e6e6e6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "369.018 333.079 356.629 366.828 356.64 520.587 371.736 524.916 369.018 333.079",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M528.363,402.136c-12.05744.34245-21.2569,21.20913-21.03568,29.35186l.40705,14.74161,43.65914-1.20557-.40705-14.74161C550.75786,422.1398,540.42089,401.81259,528.363,402.136Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M497.31046,550.89488a8.50984,8.50984,0,0,1-8.73142-8.26213l-.66249-23.99087a8.5,8.5,0,1,1,16.99353-.46923l.66248,23.99087A8.50981,8.50981,0,0,1,497.31046,550.89488Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#3f3d56"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "320.125 339.284 319.82 323.429 323.978 323.326 324.283 339.13 328.052 569.476 323.893 569.591",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M568.3137,498.37505l-74.73857,2.0638c-7.13852-8.70518-7.78692-45.79259,7.11089-52.85111l5.8423-9.92024,45.04258-2.19882,5.26415,10.44507C564.24572,452.21964,568.06692,489.07551,568.3137,498.37505Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M540.18331,480.58758l-18.90006.52192c-3.64714.10071-6.74794-4.631-6.91129-10.54634s2.67166-10.811,6.3188-10.91168l18.90007-.52192c3.64714-.10071,6.74793,4.631,6.91128,10.54634S543.83045,480.48687,540.18331,480.58758Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#c41437"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "310.043 465.568 271.084 493.088 264.278 555.138 309.726 539.953 310.043 465.568",
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 623.87687,
    y: 457.18614,
    width: 64.47382,
    height: 217.68039,
    transform: "translate(-208.91465 -103.68767) rotate(-1.58175)",
    fill: "#e6e6e6"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "428.888 333.806 442.149 367.222 446.128 520.93 431.149 525.649 428.888 333.806",
    fill: "#ccc"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 524.02404,
    cy: 262.58361,
    rx: 8.44737,
    ry: 11.32747,
    fill: "#e6e6e6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 568.18345,
    cy: 428.88373,
    rx: 8.44737,
    ry: 11.32747,
    fill: "#e6e6e6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.47141,
    cy: 397.09412,
    rx: 8.44737,
    ry: 11.32747,
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M651.51553,399.50588c-12.05744.34245-21.25689,21.20914-21.03567,29.35186l.407,14.74162,43.65913-1.20558-.407-14.74161C673.91039,419.50962,663.57349,399.1824,651.51553,399.50588Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#3f3d56"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "470.459 344.247 470.154 328.392 474.312 328.288 474.617 344.093 478.386 574.439 474.227 574.554",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M691.46628,495.74489l-74.73849,2.0638c-1.30315-7.87682.38259-44.63292,7.11089-52.85111l5.84229-9.92024,45.04259-2.19882,5.26415,10.44507C693.28642,444.36732,697.93794,480.48676,691.46628,495.74489Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#e6e6e6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M663.42733,481.26809l-18.90007.52193c-3.64714.1007-6.76843-5.37373-6.957-12.2017s2.626-12.46635,6.273-12.56707l18.90007-.52193c3.64714-.1007,6.76843,5.37372,6.957,12.20169S667.07441,481.16736,663.42733,481.26809Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#c41437"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "494.978 449.662 532.641 478.93 536.607 541.227 491.901 523.983 494.978 449.662",
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M678.00058,283.1349c-40.4127,0-86.85713-44.8462-127.94893-23.53858-124.415,64.51367-107.28857-43.43994-143.032-83.58887l1.17348-2.35367c27.05948,103.21822,51.543,267.6924,142.39881,83.20476,22.75921-46.21385,97.45511,25.21995,141.4233,23.11264l.0763,2.8291Q685.12651,283.1363,678.00058,283.1349Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#f2f2f2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M774.99759,289.481c-32.21552,24.39974-96.31583,16.69148-116.20792,58.48688-60.228,126.54524-111.754,30.14827-164.48777,19.72361l-.48561-2.58476c52.79008,4.37844,109.41447-2.4151,163.75111-19.64751,49.10435-15.57131,92.91452-38.73551,126.692-66.96178l1.76894,2.20918Q780.67894,285.17977,774.99759,289.481Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#f2f2f2"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 231.02404,
    cy: 150.58361,
    rx: 8.44737,
    ry: 11.32747,
    fill: "#e6e6e6"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 493.02404,
    cy: 58.58361,
    rx: 8.44737,
    ry: 11.32747,
    fill: "#e6e6e6"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 222.57667,
    cy: 296.00706,
    rx: 8.44737,
    ry: 11.32747,
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M501.903,329.64336c-3.862,2.57318-7.81469-3.55124-3.87847-6.01019C501.88638,321.06014,505.83908,327.18459,501.903,329.64336Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#e6e6e6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M644.903,128.64337c-3.862,2.57319-7.81469-3.55124-3.87847-6.01017C644.88638,120.06014,648.83908,126.18458,644.903,128.64337Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#e6e6e6"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "535.641 125.801 533.184 125.262 533.722 122.804 532.084 122.445 531.545 124.903 529.088 124.365 528.729 126.003 531.186 126.542 530.648 128.999 532.286 129.358 532.825 126.9 535.282 127.439 535.641 125.801",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 310.42687,
    cy: 32.73714,
    r: 10.70233,
    fill: "#ff6584"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M582.24819,141.20465c-12.05744.34245-21.2569,21.20915-21.03568,29.35188l.40705,14.74161,43.65913-1.20556-.40711-14.74162C604.64305,161.20839,594.30614,140.8812,582.24819,141.20465Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M608.24508,699.42335l-19.83215.54763a13.81226,13.81226,0,0,1-8.48582-2.37891c-2.15368-1.602-3.14165-3.76765-2.70848-5.94251l3.90259-19.61285c.73552-3.7,5.2696-6.49714,10.78-6.64927l10.95246-.30244c5.5104-.15213,10.19189,2.39044,11.1305,6.04427l4.9789,19.36752c.55246,2.1477-.31448,4.36453-2.37641,6.08292A13.81214,13.81214,0,0,1,608.24508,699.42335Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 558.70021,
    y: 235.85625,
    width: 64.47382,
    height: 440.01582,
    transform: "translate(-205.89866 -105.52873) rotate(-1.58175)",
    fill: "#e6e6e6"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "397.76 325.949 397.455 310.094 401.613 309.991 401.918 325.795 405.687 556.141 401.528 556.256",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M629.77769,275.30579l-87.32589,2.41139c-1.52253-9.20342.447-52.14995,8.30847-61.75224l2.15433-11.462,60.29654-1.665,3.15478,11.17106C625.02452,221.37694,629.48931,264.44,629.77769,275.30579Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#e6e6e6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M615.11716,204.1904l-62.22262,1.7182c-2.29662.06335-4.19309-1.14245-4.23579-2.69338a1.952,1.952,0,0,1,.09665-.65849l9.66494-29.77518c.41385-1.275,2.06138-2.21137,3.98418-2.26446l41.26444-1.13938c1.9228-.05309,3.61947.79092,4.10307,2.04114l11.29335,29.19646c.57762,1.4933-.75639,3.04723-2.97964,3.47082A6.08056,6.08056,0,0,1,615.11716,204.1904Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M559.03257,445.94067a7.62637,7.62637,0,0,1-1.58088-.915,5.60392,5.60392,0,0,1-2.37913-4.32149l-2.26085-81.87757c-.09309-3.3894,3.22545-6.24062,7.39768-6.356l55.70318-1.53841c4.17306-.116,7.64291,2.54888,7.7371,5.93821l2.26072,81.878a5.60268,5.60268,0,0,1-2.13683,4.44594,8.50615,8.50615,0,0,1-5.2613,1.90983l-55.70233,1.53768A8.91988,8.91988,0,0,1,559.03257,445.94067Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M594.68505,198.921l-18.90007.52192c-3.64714.10071-6.73109-4.01989-6.87367-9.18422s2.70927-9.44884,6.35641-9.54955l18.90006-.52192c3.64714-.1007,6.7311,4.01989,6.87367,9.18422S598.33219,198.82031,594.68505,198.921Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#c41437"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M686.9305,545.58023a8.50984,8.50984,0,0,1-8.73142-8.26213l-.66249-23.99088a8.5,8.5,0,0,1,16.99352-.4692l.66248,23.99087A8.50984,8.50984,0,0,1,686.9305,545.58023Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M376.491,613.60924c-10.24609,0-16.90722-2.5459-19.85547-7.60742-5.814-9.98047,3.92334-27.49317,28.94092-52.05078l2.10157,2.14062c-23.23877,22.8125-33.34278,40.001-28.45069,48.40039,3.0957,5.3125,12.3086,7.2168,26.64844,5.50391,14.23535-1.69922,33.10058-6.76465,56.07178-15.05469,47.291-17.06738,106.62255-45.85644,167.06494-81.06445,60.44043-35.207,114.75049-72.61621,152.92676-105.335,7.33252-6.28565,13.9873-12.33252,19.77929-17.97119a196.96057,196.96057,0,0,0,20.97559-23.37745c8.563-11.627,11.45312-20.58105,8.35791-25.89453-5.16992-8.87451-26.8877-8.04-61.15625,2.353l-.87012-2.87109c36.76611-11.14893,58.50733-11.4834,64.61865-.9917,3.79737,6.51855.92578,16.3374-8.53418,29.18359a199.923,199.923,0,0,1-21.29882,23.74756c-5.83692,5.6831-12.53907,11.77246-19.91993,18.09961-38.30957,32.83349-92.77685,70.354-153.36914,105.64892-60.59375,35.29688-120.10009,64.168-167.55615,81.29493-23.18506,8.36718-42.27344,13.48535-56.73486,15.21093A82.69543,82.69543,0,0,1,376.491,613.60924Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#3f3d56"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "423.268 139.256 460.93 168.524 464.896 230.821 420.19 213.577 423.268 139.256",
    fill: "#e6e6e6"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "366.372 139.256 328.71 168.524 324.744 230.821 369.45 213.577 366.372 139.256",
    fill: "#e6e6e6"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "387.625 93.825 387.32 77.97 391.478 77.867 391.783 93.672 395.552 124.018 391.393 124.133",
    fill: "#3f3d56"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 389.53599,
    cy: 336.70304,
    rx: 7.55666,
    ry: 5.25681,
    transform: "translate(-288.82152 41.31149) rotate(-21.16137)",
    fill: "#e6e6e6"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 438.5395,
    cy: 330.4169,
    rx: 7.55666,
    ry: 5.2568,
    transform: "translate(-283.24781 58.57767) rotate(-21.16137)",
    fill: "#e6e6e6"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 385.28607,
    cy: 378.51122,
    rx: 7.55666,
    ry: 5.25681,
    transform: "translate(-304.20069 42.59652) rotate(-21.16137)",
    fill: "#e6e6e6"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 371.90739,
    cy: 397.20791,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-275.02907 -25.67394) rotate(-13.31636)",
    fill: "#e6e6e6"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 371.6158,
    cy: 428.4305,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-282.22834 -24.90163) rotate(-13.31636)",
    fill: "#e6e6e6"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 414.62479,
    cy: 363.76125,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-266.17684 -16.73422) rotate(-13.31636)",
    fill: "#e6e6e6"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 388.81592,
    cy: 357.49392,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-265.42722 -22.84723) rotate(-13.31636)",
    fill: "#e6e6e6"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 416.17145,
    cy: 328.74316,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-258.06962 -17.31951) rotate(-13.31636)",
    fill: "#e6e6e6"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 818.54827,
    cy: 477.57793,
    rx: 7.55666,
    ry: 5.25681,
    transform: "translate(-288.87432 104.72215) rotate(-14.91271)",
    fill: "#e6e6e6"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 769.15169,
    cy: 478.49301,
    rx: 7.55666,
    ry: 5.2568,
    transform: "translate(-290.77354 92.0409) rotate(-14.91271)",
    fill: "#e6e6e6"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 827.3235,
    cy: 436.48072,
    rx: 7.55666,
    ry: 5.25681,
    transform: "translate(-278.00252 105.59623) rotate(-14.91271)",
    fill: "#e6e6e6"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 842.65771,
    cy: 419.3513,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-238.73538 -15.14542) rotate(-7.0677)",
    fill: "#e6e6e6"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 846.34595,
    cy: 388.34594,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-234.8924 -14.92721) rotate(-7.0677)",
    fill: "#e6e6e6"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 796.55364,
    cy: 447.94972,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-242.60452 -20.60085) rotate(-7.0677)",
    fill: "#e6e6e6"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 821.52702,
    cy: 456.98896,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-243.52696 -17.45939) rotate(-7.0677)",
    fill: "#e6e6e6"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 791.20467,
    cy: 482.59142,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-246.90755 -20.99578) rotate(-7.0677)",
    fill: "#e6e6e6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M912.19155,645.25138q-19.36816,0-42.45655-1.46387c-79.61377-5.05566-182.73779-22.63281-290.376-49.49219C471.72127,567.436,372.42879,534.50138,299.77352,501.561c-35.39258-16.04688-62.55616-31.23633-80.73536-45.14746-19.24707-14.727-27.666-27.564-25.02392-38.15284,5.148-20.6289,50.731-25.14208,88.064-25.29541l.0127,3c-51.26807.21045-81.51367,8.38672-85.16553,23.022-4.65185,18.64013,33.28662,47.74072,104.08692,79.84131,72.4956,32.86813,171.60546,65.73922,279.07321,92.55661,107.46728,26.8164,210.40136,44.36328,289.83984,49.4082,77.57861,4.92773,124.74317-2.9375,129.39453-21.57813,3.86182-15.47656-21.59814-38.27539-71.68945-64.19824l1.37891-2.66406c36.397,18.83594,78.6455,45.85156,73.22168,67.58887-2.64252,10.58886-16.10541,17.96484-40.01508,21.92285C948.58656,644.12052,931.84584,645.25138,912.19155,645.25138Z",
    transform: "translate(-193.54052 -122.01419)",
    fill: "#c41437"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawToTheStarsRed);
export default __webpack_public_path__ + "static/media/UndrawToTheStarsRed.0eddb9cd6a6b16b91f47e3624a69cc24.svg";
export { ForwardRef as ReactComponent };